import { api } from '../../lib/api.ts';

export interface VendorType {
  id: string;
  name: string;
  createdAt: string;
}

export const vendorTypesApi = {
  list: () =>
    api.get<{ vendorTypes: VendorType[] }>('/vendor-types').then((r) => r.data.vendorTypes),
  create: (name: string) =>
    api.post<{ vendorType: VendorType }>('/vendor-types', { name }).then((r) => r.data.vendorType),
  rename: (id: string, name: string) =>
    api.patch<{ vendorType: VendorType }>(`/vendor-types/${id}`, { name }).then((r) => r.data.vendorType),
  remove: (id: string) =>
    api.delete(`/vendor-types/${id}`),
};
